const colors = {
  brand: "#014049",
  brand2: "#89AE64",
  lightGreen: "#F0F5EB",
  text1: "#232735",
  text2: "#505565",
};
export default colors;
